import { render, staticRenderFns } from "./BreakdownTotalSwitcher.vue?vue&type=template&id=097667e8"
import script from "./BreakdownTotalSwitcher.vue?vue&type=script&lang=js"
export * from "./BreakdownTotalSwitcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/dev.ideabuddy.com/public_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('097667e8')) {
      api.createRecord('097667e8', component.options)
    } else {
      api.reload('097667e8', component.options)
    }
    module.hot.accept("./BreakdownTotalSwitcher.vue?vue&type=template&id=097667e8", function () {
      api.rerender('097667e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Charts/Breakdown/BreakdownTotalSwitcher.vue"
export default component.exports